<div class="toggle-list">
  <div *ngIf="name" class="label">{{name}}</div>
  <div *ngIf="description" class="description">{{description}}</div>
  <app-task-toggle-group *ngFor="let field of fields"
                         [field]="field"
                         [(ngModel)]="field.value"
                         (valueChanged)="updateToggleListControl($event)"
  ></app-task-toggle-group>
</div>
